import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TextField from "@material-ui/core/TextField";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import { ThemeProvider } from '@material-ui/core'
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  overrides: {
      MuiTableCell: {
          root: { 
              padding: "10px 0 10px 0"
          },
      },
      MuiTableContainer: {
        root: { 
          padding: "0px 5vw 0px 5vw"
        },
      }
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected, title, setFilter, show, done, fetchInspections, nInsp } = props;
  const [ query, setQuery ] = React.useState("")

  const text = (done ? "All Inspections Loaded From Cloud " : "Load More Inspections From Cloud ") + "(Total Loaded:"+nInsp+")"

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Grid lg={6} xs={6} item align="center">
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle">
          {title}
        </Typography>
      )}
      </Grid>
      
      <Grid lg={4} xs={4} item align="center">
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Search Bar">
        <TextField
          label="Search"
          hintText="Query"
          floatingLabelText="Query"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
            setFilter(e.target.value)
          }}
          floatingLabelFixed
        />
        </Tooltip>
      )}
      </Grid>
      
      {show ? (
        <Tooltip title={text}>
        {/* <IconButton color="primary" size="Large" disabled={done}
        onClick={() => {
          fetchInspections()
        }}
        >
          <CloudDownloadOutlinedIcon/>
        </IconButton> */}
        <Grid lg={2} xs={2} item align="center">
          <Button variant="contained" color="primary" startIcon={<CloudDownloadOutlinedIcon />} disabled={done} onClick={() => {
                  fetchInspections()
                }}>
                Load
          </Button>
        </Grid>
        
      </Tooltip>
      ) : (<></>)
      }
      
      
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    margin:"auto"
  },
  paper: {
    width: '100%',
    margin: "auto",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    textAlign: "middle"
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

const Photo = props => {
  var { photoKey, getPhoto } = props
  const [photo, setPhoto] = React.useState(null)

  React.useEffect(() => {
    getPhoto(photoKey)
    .then((photo) => {
      setPhoto(photo)
    })
    .catch(err => { 
      console.log(err)
    })
  }, [getPhoto, photoKey])

  return (<img alt="N/A" width="200px" src={photo} />)
}

export default function EnhancedTable(props) {
  var { title, headCells, rows, getPhoto, show, fetchInspections, done, nInsp } = props

  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected,] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense,] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [filter, setFilter] = React.useState("")

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = name => selected.indexOf(name) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  if (filter !== "") {
    rows = rows.filter(x => 
        x["query"]
        .includes(filter.toLowerCase())
      )
  }

  return (
    <ThemeProvider theme={theme}>
 
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar title={title} setFilter={setFilter} numSelected={selected.length} show={show} done={done} nInsp={nInsp} fetchInspections={()=>fetchInspections()}/>
        
        <TableContainer style={{width:"100%", padding:"5 5 5 5", margin:"auto"}}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              headCells={headCells}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${row.id}`;
                  
                  return (
                    <Tooltip title={row.description}>
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        
                          <TableCell component="th" id={labelId} scope="row">
                            <Link style={{ display:"block", textDecoration: 'none', color: 'inherit', width:"100%"}} to={`${row.to}?${row.id}`}>
                              {row[headCells[0].id]}
                            </Link>
                          </TableCell>
                          {[...Array(headCells.length - 1).keys()].map((i) => {
                            return (
                              <TableCell align="right">
                                {(headCells[i+1].id === 'photo') &&
                                  <Photo photoKey={row['photo']} getPhoto={getPhoto}/>
                                }
                                {!(headCells[i+1].id === 'photo') &&
                                  <Link style={{ display:"block", width: "100%", textDecoration: 'none', color: 'inherit'}} to={`${row.to}?${row.id}`}>
                                    {row[headCells[i+1].id]}
                                  </Link>
                                }
                                
                              </TableCell>
                            )
                          })}
                        
                      </TableRow>
                      </Tooltip>
                    
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[15, 25, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
    </ThemeProvider>
  );
}
